var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWetuDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2",
    x: 0,
    y: 0,
    width: 212,
    height: 212,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-577 -240)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 71,
    cy: 71,
    r: 71,
    transform: "translate(612 275)",
    fill: "#c6e1b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-284 105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 861, 135)",
    filter: "url(#Ellipse_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    d: "M76,8a68,68,0,1,0,68,68A68.077,68.077,0,0,0,76,8m0-8A76,76,0,1,1,0,76,76,76,0,0,1,76,0Z",
    transform: "translate(30 30)",
    fill: "#fcfcff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M11.07,61.62a7.161,7.161,0,0,0,7.14,7.14H46.77a7.161,7.161,0,0,0,7.14-7.14V18.78H11.07ZM19.852,36.2l5.034-5.034,7.6,7.568,7.568-7.568L45.092,36.2,37.524,43.77l7.568,7.568-5.034,5.034L32.49,48.8l-7.568,7.568-5.034-5.034,7.568-7.568ZM44.985,8.07,41.415,4.5H23.565L20,8.07H7.5v7.14H57.48V8.07Z",
    transform: "translate(650.5 309.37)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWetuDeleteIcon);
export default __webpack_public_path__ + "static/media/wetu-delete-icon.0df43ee991a15bc037b932db070febed.svg";
export { ForwardRef as ReactComponent };